import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
  Hidden,
  Button,
  Paper,
} from "@material-ui/core";
import React from "react";
import CustomTable from "./tableContent";
import CustomTableMobile from "./tableContentMobile";
import EmptyImg from "../../../../assets/images/empty-folder.png";
import { Link } from "react-router-dom";

export default function ActivityTable(props) {
  const { totalItems, handleNavUpdate } = props;
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Box>
      {totalItems > 0 ? (
        <Grid container spacing={xs ? 1 : 3}>
          <Hidden xsDown>
            <Grid item xs={12}>
              <CustomTable {...props} />
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Grid item xs={12}>
              <CustomTableMobile {...props} />
            </Grid>
          </Hidden>
        </Grid>
      ) : (
        <Paper>
          <Box p={3}>
            <Grid
              container
              direction="column"
              justifyContent="space-between"
              alignItems="center"
              spacing={5}
            >
              <Grid item xs={12} style={{ opacity: 0.5 }}>
                <img
                  src={EmptyImg}
                  alt="empty folder icon"
                  style={{ height: 128 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" style={{ textAlign: "center" }}>
                  No transactions found. Try changing the filter or YOOZing it
                  now!.
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                container
                direction="row"
                justifyContent="space-evenly"
                alignItems="center"
              >
                <Grid item>
                  <Button
                    component={Link}
                    to="/user/billpay"
                    color="primary"
                    variant="contained"
                    style={{ borderRadius: 50 }}
                    onClick={() => handleNavUpdate(1)}
                  >
                    Pay Bills Now
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    component={Link}
                    to="/user/billpay"
                    color="secondary"
                    variant="contained"
                    style={{ borderRadius: 50 }}
                    onClick={() => handleNavUpdate(2)}
                  >
                    Top Up Now
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      )}
    </Box>
  );
}
